function initHotspots() {

  const hotspots = document.querySelectorAll(".hotspot");

  hotspots.forEach((hotspot) => {

    if(hotspot.dataset.loaded) return;

    hotspot.dataset.loaded = "true";

    const button = hotspot.querySelector(".hotspot__btn");

    button.addEventListener("click", (e) => {

      e.preventDefault();
      e.stopPropagation();

      hotspots.forEach((item) => {
        if(item !== hotspot){
          item.classList.remove("active");
        }
      });

      hotspot.classList.toggle("active");

    });

  });

  document.addEventListener("click", () => {
    hotspots.forEach((item) => {
      item.classList.remove("active");
    });
  });

}

document.addEventListener("DOMContentLoaded", initHotspots);
document.addEventListener("shopify:section:load", initHotspots);